import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaiairportcab() {



  const cardData = {
    keyword: " Navi Mumbai Airport Cab ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai Airport cab service, providing safe, comfortable, and affordable transportation for airport pickups, drops, local travel, corporate transfers, and outstation journeys. Whether you are traveling for business, family trips, or daily commute, our professional drivers and well-maintained vehicles ensure a smooth and stress-free travel experience. We specialize in punctual airport transfers with real-time flight tracking, luggage assistance, and doorstep service across Navi Mumbai, Mumbai, and nearby cities. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for individuals as well as group travel. With transparent pricing, 24/7 availability, and easy online booking, Royal Route Cab is a trusted choice for Navi Mumbai Airport cab service.",

"topPlaces": [
  {
    "title": "Navi Mumbai Airport Cab Service",
    "description": "Navi Mumbai airport cab service provides reliable and comfortable transportation for passengers traveling to and from the upcoming Navi Mumbai International Airport. It ensures timely pickups, smooth rides, and hassle-free travel experience for all passengers."
  },
  {
    "title": "Airport Transfer Cab Navi Mumbai",
    "description": "Airport transfer cab service in Navi Mumbai is ideal for business travelers and tourists who need punctual and convenient transportation. It offers comfortable vehicles with professional drivers for stress-free airport journeys."
  },
  {
    "title": "Navi Mumbai to Mumbai Airport Cab",
    "description": "Navi Mumbai to Mumbai airport cab service is widely used for inter-airport and city transfers. It provides a smooth and comfortable ride with timely service for domestic and international passengers."
  },
  {
    "title": "Local Cab Service Navi Mumbai Airport Area",
    "description": "Local cab service around Navi Mumbai airport area offers quick and efficient transportation for nearby residential and commercial zones. It is suitable for daily commuting and short-distance travel."
  },
  {
    "title": "One Way Cab to Navi Mumbai Airport",
    "description": "One way cab service to Navi Mumbai airport is perfect for passengers looking for convenient drop services without return booking. It ensures affordability and comfort for airport travel."
  },
  {
    "title": "Corporate Cab Service Navi Mumbai Airport",
    "description": "Corporate cab service for Navi Mumbai airport is designed for business travelers and companies requiring reliable transport for employees and clients. It ensures punctual and professional service."
  },
  {
    "title": "Navi Mumbai Airport Pickup Cab",
    "description": "Navi Mumbai airport pickup cab service offers seamless arrival assistance for passengers, ensuring comfortable transport from the airport to hotels, offices, or residential locations."
  },
  {
    "title": "Navi Mumbai Airport Drop Cab Service",
    "description": "Navi Mumbai airport drop cab service provides timely and safe transportation for passengers heading to the airport, ensuring stress-free travel and on-time arrival."
  },
  {
    "title": "Affordable Navi Mumbai Airport Cab",
    "description": "Affordable Navi Mumbai airport cab service offers budget-friendly transportation options without compromising on comfort, safety, and reliability for all types of travelers."
  },
  {
    "title": "Luxury Cab Service Navi Mumbai Airport",
    "description": "Luxury cab service for Navi Mumbai airport provides premium vehicles with enhanced comfort, making it ideal for VIP travelers, executives, and special occasions."
  }
],






services: [
  {
    name: "Navi Mumbai Airport Cab",
    description: "Navi Mumbai airport cab service offers reliable and comfortable transportation for airport transfers. Ideal for individuals, families, and corporate travelers, this service ensures timely pickup and drop. Professional drivers and clean vehicles enhance comfort. It guarantees a smooth airport travel experience."
  },
  {
    name: "Navi Mumbai Airport Taxi",
    description: "Navi Mumbai airport taxi provides convenient and private rides to and from the airport. This service includes door-to-door pickup with flexible scheduling. Comfortable seating ensures a pleasant journey. It guarantees a hassle-free airport transfer."
  },
  {
    name: "Navi Mumbai Airport Cab Booking",
    description: "Navi Mumbai airport cab booking allows customers to reserve rides easily with instant confirmation. Travelers can choose vehicle type, pickup location, and travel time. Transparent pricing ensures no hidden charges. It simplifies airport travel planning."
  },
  {
    name: "Navi Mumbai Airport Taxi Service",
    description: "Navi Mumbai airport taxi service ensures dependable transportation with professional drivers and well-maintained vehicles. This service is ideal for timely airport transfers. Flexible booking options enhance convenience. It guarantees a stress-free journey."
  },
  {
    name: "Cab to Navi Mumbai Airport",
    description: "Cab to Navi Mumbai airport provides quick and reliable drop services from any location. This service ensures punctual arrival for flights. Comfortable vehicles and experienced drivers enhance safety. It ensures smooth travel."
  },
  {
    name: "Taxi to Navi Mumbai Airport",
    description: "Taxi to Navi Mumbai airport offers convenient and timely transportation for departures. This service is ideal for individuals and groups. Flexible pickup options ensure comfort. It guarantees a reliable airport drop."
  },
  {
    name: "Navi Mumbai Airport Drop Cab",
    description: "Navi Mumbai airport drop cab ensures timely and safe drop services to the airport. This service is ideal for catching flights without delays. Professional drivers ensure punctuality. It guarantees a hassle-free experience."
  },
  {
    name: "Navi Mumbai Airport Pickup Cab",
    description: "Navi Mumbai airport pickup cab provides seamless pickup services from arrival terminals. Drivers track flights to ensure timely service. Comfortable vehicles enhance travel experience. It ensures a smooth pickup."
  },
  {
    name: "Book Cab for Navi Mumbai Airport",
    description: "Book cab for Navi Mumbai airport with easy online booking and instant confirmation. Customers can select vehicle type and timing based on convenience. Transparent pricing ensures trust. It simplifies airport travel."
  },
  {
    name: "Online Cab Booking Navi Mumbai Airport",
    description: "Online cab booking Navi Mumbai airport provides a quick and convenient way to reserve your ride. Secure payment and instant confirmation enhance convenience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Navi Mumbai Airport Cab Near Me",
    description: "Navi Mumbai airport cab near me helps travelers find nearby cabs quickly for urgent travel needs. This service ensures quick response and reliable drivers. Ideal for last-minute bookings. It guarantees instant availability."
  },
  {
    name: "Cheapest Cab to Navi Mumbai Airport",
    description: "Cheapest cab to Navi Mumbai airport offers budget-friendly airport transfers without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Best Cab Service Navi Mumbai Airport",
    description: "Best cab service Navi Mumbai airport ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on safety, comfort, and punctuality. It guarantees a premium airport travel experience."
  },
  {
    name: "Reliable Airport Cab Navi Mumbai",
    description: "Reliable airport cab Navi Mumbai provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and drops. It guarantees a safe and comfortable journey."
  },
  {
    name: "Innova Cab to Navi Mumbai Airport",
    description: "Innova cab to Navi Mumbai airport is perfect for families and groups seeking spacious and comfortable travel. Premium seating and ample luggage space enhance the journey. It ensures a comfortable airport transfer."
  },
  {
    name: "Ertiga Cab to Navi Mumbai Airport",
    description: "Ertiga cab to Navi Mumbai airport offers affordable and spacious travel for small groups. Comfortable seating and good mileage make it ideal for airport transfers. It ensures a pleasant ride."
  },
  {
    name: "Sedan Cab to Navi Mumbai Airport",
    description: "Sedan cab to Navi Mumbai airport is ideal for individuals and couples seeking economical travel. Sedans offer smooth rides and comfort. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "SUV Cab to Navi Mumbai Airport",
    description: "SUV cab to Navi Mumbai airport provides spacious and comfortable travel for families and groups. SUVs offer extra luggage space and better comfort. It ensures a comfortable airport journey."
  },
  {
    name: "Tempo Traveller to Navi Mumbai Airport",
    description: "Tempo Traveller to Navi Mumbai airport is ideal for large groups and corporate travel. Spacious seating and group-friendly features make it perfect for airport transfers. It ensures a convenient group travel experience."
  },
  {
    name: "Corporate Cab to Navi Mumbai Airport",
    description: "Corporate cab to Navi Mumbai airport offers professional travel solutions for business clients. This service includes punctual pickups, clean vehicles, and trained drivers. It ensures efficient corporate travel."
  },
  {
    name: "Luxury Cab Navi Mumbai Airport",
    description: "Luxury cab Navi Mumbai airport provides premium vehicles for high-end travel. Ideal for executives and VIP clients. Comfortable interiors and professional chauffeurs enhance experience. It guarantees luxury travel."
  },
  {
    name: "Airport Transfer Service Navi Mumbai",
    description: "Airport transfer service Navi Mumbai ensures seamless pickup and drop services with professional drivers. This service is ideal for smooth airport travel. Flexible booking enhances convenience. It guarantees a stress-free experience."
  },
  {
    name: "Executive Airport Cab Navi Mumbai",
    description: "Executive airport cab Navi Mumbai offers premium travel for business professionals. This service ensures punctuality, comfort, and reliability. Ideal for corporate clients. It guarantees a high-quality experience."
  },
  {
    name: "Innova Crysta Navi Mumbai Airport Cab",
    description: "Innova Crysta Navi Mumbai airport cab offers luxury and spacious travel for families and corporate clients. Premium interiors and smooth performance enhance comfort. It ensures a high-end airport transfer experience."
  },
  {
    name: "Swift Dzire Cab Navi Mumbai Airport",
    description: "Swift Dzire cab Navi Mumbai airport provides economical and comfortable travel for individuals and couples. Smooth rides and fuel efficiency make it ideal for airport transfers. It ensures a budget-friendly journey."
  },
  {
    name: "Hyundai Aura Cab Navi Mumbai Airport",
    description: "Hyundai Aura cab Navi Mumbai airport offers modern and comfortable travel with stylish interiors. Ideal for city and airport transfers. Professional drivers ensure safety. It ensures a smooth travel experience."
  }
],

tableData: [
  ["Navi Mumbai Airport Cab", "Navi Mumbai Airport Taxi"],
  ["Navi Mumbai Airport Cab Booking", "Navi Mumbai Airport Taxi Service"],
  ["Cab to Navi Mumbai Airport", "Taxi to Navi Mumbai Airport"],
  ["Navi Mumbai Airport Drop Cab", "Navi Mumbai Airport Pickup Cab"],
  ["Book Cab for Navi Mumbai Airport", "Online Cab Booking Navi Mumbai Airport"],
  ["Navi Mumbai Airport Cab Near Me", "Cheapest Cab to Navi Mumbai Airport"],
  ["Best Cab Service Navi Mumbai Airport", "Reliable Airport Cab Navi Mumbai"],
  ["Innova Cab to Navi Mumbai Airport", "Ertiga Cab to Navi Mumbai Airport"],
  ["Sedan Cab to Navi Mumbai Airport", "SUV Cab to Navi Mumbai Airport"],
  ["Tempo Traveller to Navi Mumbai Airport", "Corporate Cab to Navi Mumbai Airport"],
  ["Luxury Cab Navi Mumbai Airport", "Executive Airport Cab Navi Mumbai"],
  ["Innova Crysta Navi Mumbai Airport Cab", "Swift Dzire Cab Navi Mumbai Airport"],
  ["Hyundai Aura Cab Navi Mumbai Airport", ""]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai Airport Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service to and from Navi Mumbai Airport, ensuring smooth pickup and drop for all travelers."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We monitor flight timings to provide timely pickup even during delays, ensuring a hassle-free airport travel experience."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport cab service operates round the clock, perfect for late-night arrivals and early morning departures."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, courteous, and experienced in airport routes, ensuring safe and comfortable travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and parking charges with no hidden costs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for a comfortable ride."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable airport transfers in Navi Mumbai with punctual service and smooth experience."
  }
]

};

const faqData = [
  { question: "Do you provide cab service to Navi Mumbai Airport?", answer: "Yes, Royal Route Cabs offers reliable cab services for pickup and drop to Navi Mumbai Airport." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Navi Mumbai Airport cab service operates 24/7." },
  { question: "Do you provide airport pickup from all areas?", answer: "Yes, we provide pickup from Mumbai, Navi Mumbai, Thane, and nearby locations." },
  { question: "What is the average airport cab fare?", answer: "Airport cab fares typically range from ₹800 to ₹2500 depending on distance and vehicle type." },
  { question: "Do you track flight timings?", answer: "Yes, we track flights to ensure timely pickup even in case of delays." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book online or via phone for airport transfers." },
  { question: "Do you provide one-way airport drop?", answer: "Yes, we provide one-way and round-trip airport cab services." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended to ensure availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Patil",
    feedback: "The Navi Mumbai Airport cab service with Royal Route Cabs was very punctual and smooth. The pickup was on time and the ride felt comfortable and stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback: "Great airport cab experience in Navi Mumbai. The vehicle was clean, the driver was professional, and the journey was handled very efficiently.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-airport-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai Airport cab service with Royal Route Cabs for safe, reliable, and on-time airport pickup and drop. Available 24x7 with sedan, SUV, Innova, Ertiga, and premium vehicles for hassle-free travel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting airport transfer fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-airport-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Navi Mumbai Airport Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport cab with Royal Route Cabs. Reliable airport pickup and drop taxi service available 24x7 with affordable fares and comfortable vehicles."
  />

  <meta
    name="keywords"
    content="navi mumbai airport cab, navi mumbai airport taxi, navi mumbai airport cab booking, navi mumbai airport taxi service, cab to navi mumbai airport, taxi to navi mumbai airport, navi mumbai airport drop cab, navi mumbai airport pickup cab, book cab for navi mumbai airport, online cab booking navi mumbai airport, navi mumbai airport cab near me, cheapest cab to navi mumbai airport, best cab service navi mumbai airport"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcab;